export const MAX_SOM_CUSTOM_PROMPT_TEXT = 4000;

export function isCanonicalSomPrompt(prompt) {
  return prompt?.prompt_type === 'som' && prompt?.metadata?.source === 'som';
}

export function isCustomSomPrompt(prompt) {
  return prompt?.prompt_type === 'som' && prompt?.metadata?.source === 'som_custom';
}

export function canRunNowPrompt(prompt) {
  return isCustomSomPrompt(prompt) && prompt?.active === true;
}

export function splitSomPrompts(prompts = []) {
  const canonical = prompts
    .filter(isCanonicalSomPrompt)
    .sort((a, b) => (a.metadata?.order || 99) - (b.metadata?.order || 99));
  const custom = prompts.filter(isCustomSomPrompt);
  return { canonical, custom };
}

export function validatePromptText(value) {
  const text = (value ?? '').trim();
  if (!text) return 'Prompt text is required.';
  if (text.length > MAX_SOM_CUSTOM_PROMPT_TEXT) {
    return `Prompt text must be at most ${MAX_SOM_CUSTOM_PROMPT_TEXT} characters.`;
  }
  return '';
}

export function somPromptApiError(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  const detailText = typeof detail === 'string' ? detail : '';
  if (status === 401) return 'Your session expired. Please sign in again.';
  if (status === 403) return detailText || 'You do not have permission to change this prompt.';
  if (status === 404) return 'Prompt or client unavailable.';
  if (status === 400) return detailText || 'Please check the form and try again.';
  if (status === 500) return 'A server error occurred. Please try again later.';
  return detailText || err?.message || 'Something went wrong.';
}

export function customPromptPayload(form) {
  const market = (form.market ?? '').trim();
  return {
    prompt_text: (form.prompt_text ?? '').trim(),
    market: market || null,
    language: (form.language ?? 'en').trim() || 'en',
    priority: form.priority || 'medium',
  };
}
